import { ReactElement } from "react";
import { localize } from "client_legacy/ndaw/culture";
import { Dialog } from "client/Components";

export const PasswordResetSuccessfullyDialog = (): ReactElement => {
	return (
		<Dialog trackingId="reset-successful-dialog">
			<Dialog.Header title={localize("_TemporaryPassword")}/>
			<Dialog.Body>
				<p>{localize("_TemporaryPasswordSuccessfull")}</p>
			</Dialog.Body>
		</Dialog>
	);
};
PasswordResetSuccessfullyDialog.displayName = "PasswordResetSuccessfullyDialog";